import { Delete, Edit } from '@mui/icons-material';
import { Box, Card, CardContent, CardMedia, IconButton, Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

function ImageCard({ author, title, description, image, uploadTime, alt = '', onClick, onEdit, onDelete }) {
  const { t } = useTranslation();
  const hasAnyInformation = author != null || title != null || description != null || uploadTime != null;
  return (
    <Card>
      <CardMedia
        className="hover-div"
        component="img"
        image={image}
        alt={alt}
        loading="lazy"
        sx={{ height: 250, cursor: 'pointer' }}
        onClick={onClick}
      />
      {hasAnyInformation && (
        <CardContent>
          <Box sx={{ px: 1 }}>
            <Stack spacing={2} direction="row" justifyContent="space-between" alignItems="center">
              <div>
                {title != null && (
                  <Typography gutterBottom variant="h6" component="div" sx={{ mt: 1 }}>
                    {title}
                  </Typography>
                )}
                {description != null && (
                  <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', width: '11rem' }}>
                    <Typography variant="body2" color="text.secondary">
                      {description}
                    </Typography>
                  </div>
                )}
                {(uploadTime != null || author != null) && (
                  <Typography variant="caption" color="text.secondary">
                    {author != null && t('sites.byAuthor', 'By {{author}}', { author })}
                    {author != null && uploadTime != null && <br />}
                    {uploadTime}
                  </Typography>
                )}
              </div>
              <Stack direction="row" spacing={1}>
                {onEdit != null && (
                  <IconButton onClick={onEdit}>
                    <Edit />
                  </IconButton>
                )}
                {onDelete != null && (
                  <IconButton onClick={onDelete}>
                    <Delete />
                  </IconButton>
                )}
              </Stack>
            </Stack>
          </Box>
        </CardContent>
      )}
    </Card>
  );
}

export default ImageCard;
